import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectOfferId } from 'shared/selectors/offerData';

const OFFER_ID_TEMPLATE = '{offerId}';

export const useOfferBookingUrl = () => {
  const offerId = useSelector(selectOfferId);

  const { config } = useApplicationContext();
  const urlTemplate = config.get<string>('newbuildingBroker.offerBookingUrlTemplate') ?? /* istanbul ignore next */ '';

  return urlTemplate.replace(OFFER_ID_TEMPLATE, String(offerId));
};
